module.exports = __webpack_public_path__ + "club-fe30a0132814b909b83982a516cf3ef1.svg";